module.exports = __webpack_public_path__ + "img/propertyBanner.201ac541.png";